export class ScreenSize {
  static mobile = 'mobile';
  static desktop = 'desktop';
  static desktopMedium = 'desktopMedium';
  static desktopLarge = 'desktopLarge';
}
